module.exports = __webpack_public_path__ + "boxed-bg.7799dece2c79854f63f0.jpg";


//////////////////
// WEBPACK FOOTER
// /builds/weenect1/backofficev3/node_modules/admin-lte/dist/img/boxed-bg.jpg
// module id = ../../../../admin-lte/dist/img/boxed-bg.jpg
// module chunks = styles